<template>
    <div class="auth-management fff">
        <div class="p16 flex-row">
            <div>
                <!-- <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span> -->
                <!-- <el-divider direction="vertical" class="color999"></el-divider> -->
                <span class="color111" @click="back" style="font-size: 18px;font-weight: bold;">角色权限管理&nbsp;&nbsp;</span>
            </div>
            <!-- <div>考勤统计</div> -->
        </div>
        <!--    -->
        <div class="auth-management-top mr20">
            <!-- <h1 class="font-normal mb10">角色权限管理</h1> -->
            <el-button type="primary" style="background:rgb(32, 107, 248)" @click="add"
                v-perm="{ key: 'rolePermManager', value: 'rolePermManager:addRole' }">新增</el-button>
        </div>
        <!-- 权限列表 -->
        <div style="width: 99%;max-height: 700px;overflow-y: auto;">
            <el-table :data="roleList">
                <el-table-column :align="item.align" :label="item.label" :width="item.width" :show-overflow-tooltip="true"
                    v-for="(item, key, index) in columns" :key="index" label-class-name="selfTableClass">
                    <template slot-scope="scope">
                        <div v-if="key == 'useNumber'">{{ scope.row.useNumber }}</div>
                        <div v-else>{{ scope.row[key] }} <span
                                style="display: inline-block; width:25px;height: 20px; font-size: 10px;border: 1px solid #eee;text-align: center;"
                                v-if="scope.row.systemTag == 'yes'">默认</span></div>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="auto" align="center" label-class-name="selfTableClass">
                    <template slot-scope="scope">
                        <el-button type="text" @click="selectDetails(scope.row)"
                            v-perm="{ key: 'rolePermManager', value: 'rolePermManager:detail' }">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";

export default {
    data() {
        return {
            columns: config.columns,
            roleList: [], // 角色列表
        }
    },
    mixins: [minxin],
    created() {
        this.init()
    },

    methods: {
        async init() {
            const res = await this.$api.post(this.$url.auth.list)
            this.roleList = res
        },
        selectDetails(row) {
            this.$router.push({
                path: '/dataList/authDetails',
                query: { id: row.id, systemTag: row.systemTag, activeName: '0' }
            })
        },
        back() {
            this.$router.push("/dataList/authManagement");
        },
        add() {
            console.log(111);
            this.$router.push("/dataList/add");
        }
    }
}
</script>

<style scoped lang="less">
.auth-management {
    padding: 25px;
}

.auth-management-top {
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: flex-end;
}

/deep/.el-table .selfTableClass {
    background-color: #f2f2f2 !important;
}
</style>